import { useI18n } from "@/lib/i18n";

export default function PlatformMockup() {
  const { t } = useI18n();

  return (
    <div className="relative">
      <div aria-hidden className="absolute -inset-6 rounded-[18px] bg-secondary/60 blur-2xl opacity-60" />
      <div className="relative rounded-xl border border-border bg-card shadow-[0_30px_60px_-30px_hsl(210_28%_23%/0.25)] overflow-hidden">
        <div className="flex items-center gap-2 px-4 h-9 border-b border-border bg-background/80">
          <span className="h-2.5 w-2.5 rounded-full bg-muted" />
          <span className="h-2.5 w-2.5 rounded-full bg-muted" />
          <span className="h-2.5 w-2.5 rounded-full bg-muted" />
          <div className="ml-4 flex-1 max-w-[260px] h-5 rounded-sm bg-muted/60" />
        </div>

        <div className="flex items-center justify-between px-6 py-4 border-b border-border">
          <div className="flex items-center gap-3">
            <div className="h-7 w-7 rounded-sm bg-primary/90" />
            <div>
              <div className="font-serif text-[15px] leading-none">{t.home.mockupClinic}</div>
              <div className="text-[11px] text-muted-foreground mt-1">{t.home.mockupCatalog}</div>
            </div>
          </div>
          <div className="hidden sm:flex items-center gap-2">
            <span className="text-[11px] tracking-wide uppercase text-muted-foreground">dr Anna Nowak</span>
            <div className="h-6 w-6 rounded-full bg-secondary" />
          </div>
        </div>

        <div className="grid grid-cols-3 gap-4 p-6 bg-background">
          {[0, 1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="space-y-2.5">
              <div className="aspect-[3/4] rounded-md bg-secondary/70 relative overflow-hidden">
                <div className="absolute inset-x-6 top-5 h-3 rounded-sm bg-background/70" />
                <div className="absolute inset-x-3 top-9 bottom-3 rounded-sm bg-background/40" />
                {i === 1 && (
                  <span className="absolute top-2 right-2 text-[9px] tracking-wide uppercase bg-primary text-primary-foreground px-1.5 py-0.5 rounded-sm">
                    {t.home.mockupPersonalized}
                  </span>
                )}
              </div>
              <div className="h-2 w-3/4 rounded-sm bg-muted" />
              <div className="h-2 w-1/3 rounded-sm bg-muted/60" />
            </div>
          ))}
        </div>

        <div className="flex items-center justify-between px-6 py-3 border-t border-border bg-background/80">
          <div className="text-[11px] text-muted-foreground">{t.home.mockupProducts}</div>
          <div className="h-7 w-28 rounded-sm bg-primary/90" />
        </div>
      </div>
    </div>
  );
}
